export default __webpack_public_path__ + "static/media/map-marker.07ffc996.svg";